// Analytics readiness layer — GA4 + Meta Pixel.
// ACTIVATES ONLY when the IDs are added to frontend/.env (no IDs invented):
//   REACT_APP_GA4_MEASUREMENT_ID=G-XXXXXXXXXX
//   REACT_APP_META_PIXEL_ID=XXXXXXXXXXXXXXX
// Until then, all wiring is inert (internal /api/analytics/track still records).

const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  if (GA4_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID);
  }

  if (META_PIXEL_ID) {
    /* Meta Pixel (standard base code, condensed) */
    const w = window, d = document;
    if (!w.fbq) {
      const n = (w.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); });
      n.queue = []; n.loaded = true; n.version = "2.0";
      const t = d.createElement("script"); t.async = true;
      t.src = "https://connect.facebook.net/en_US/fbevents.js";
      d.head.appendChild(t);
      w.fbq("init", META_PIXEL_ID);
      w.fbq("track", "PageView");
    }
  }
}

// Internal event name -> canonical external event name (spec §39).
const EVENT_MAP = {
  ebook_cta: "ebook_cta_clicked",
  ebook_click: "ebook_cta_clicked",
  intake_click: "intake_started",
  checkout_start: "begin_checkout",
  checkout_complete: "initial_payment_completed",
  questionnaire_click: "questionnaire_clicked",
};

/** Forward a business event to GA4 / Meta Pixel when configured. */
export function trackExternal(eventName, source, metadata = {}) {
  const name = EVENT_MAP[eventName] || eventName;
  const params = { source, ...metadata };
  try {
    if (GA4_ID && typeof window !== "undefined" && window.gtag) {
      window.gtag("event", name, params);
    }
    if (META_PIXEL_ID && typeof window !== "undefined" && window.fbq) {
      window.fbq("trackCustom", name, params);
    }
  } catch (_) {
    /* analytics must never break UX */
  }
}
